module.exports = __webpack_public_path__ + "img/5d0b5f5226aa5.c7243739.png";